"use strict";

var LoggerInstance = require("js-logger").get("BraintreeHelper");

var AccountFormHelper = require("../accountComponents/AccountFormHelper");
var SavedPaymentsApi = require("../api/SavedPaymentsApi");
var WizardConstants = require("../constants/WizardConstants");
var Constants = require("../designer/Constants");

var ShipToAccountHelper = require("./ShipToAccountHelper");

var deviceType = Constants.DEVICE_TYPES;
var deviceMinWidth = Constants.DEVICE_MIN_WIDTHS;

var BraintreeHelper = {
	initializeBraintree: function ($parent) {
		$parent = $parent || $("body");
		this._generateIframe($parent);
	},

	isBraintreeCreditCard: function (selector) {
		var $selector = $(selector || "body");
		return Boolean(
			$selector.closest("[data-component='braintreeCreditCardPayment']").length ||
			$selector.find("[data-component='braintreeCreditCardPayment']").length
		);
	},

	isBraintreeEft: function (selector) {
		var $selector = $(selector || "body");
		return Boolean(
			$selector.closest("[data-component='eftPayment'][data-braintree-client-token]").length ||
			$selector.find("[data-component='eftPayment'][data-braintree-client-token]").length
		);
	},

	getBraintreeTokenData: function ($element, payment) {
		var that = this;
		var deferred = $.Deferred();
		var hostedFieldsInstance = $element.prop("hostedFieldsInstance");
		var clientInstance = $element.prop("clientInstance");

		var billingAddress = this._getBillingAddress(payment && payment.billingAddressInformation);

		hostedFieldsInstance.tokenize({
			billingAddress: billingAddress && billingAddress.postalCode && {
				postalCode: billingAddress.postalCode
			}
		}, function(tokenizeError, payload) {
			if (tokenizeError) {
				if (tokenizeError.details == null) {
					//All fields are blank
					$element.find("[data-component='braintreeCardNumber']").addClass("invalid");
					$element.find("[data-component='braintreeExpiration']").addClass("invalid");
					$element.find("[data-component='braintreeNameOnCard']").addClass("invalid");
					$element.find("[data-component='braintreeCardVerificationValue']").addClass("invalid");
				}
				else {
					tokenizeError.details.invalidFieldKeys.forEach(invalidKey => {
						switch (invalidKey) {
							case "number":
								$element.find("[data-component='braintreeCardNumber']").addClass("invalid");
								break;
							case "expirationDate":
								$element.find("[data-component='braintreeExpiration']").addClass("invalid");
								break;
							case "cardholderName":
								$element.find("[data-component='braintreeNameOnCard']").addClass("invalid");
								break;
							case "cvv":
								$element.find("[data-component='braintreeCardVerificationValue']").addClass("invalid");
								break;
						}
					})
				}

				var creditCardFormInvalidMessage = that._getWizardErrorMessage(WizardConstants.WIZARDS.COMPANY_ERROR_MESSAGES, WizardConstants.BRAINTREE_MESSAGE_FIELDS.CREDIT_CARD_FORM_INVALID);
				BootstrapPrompt.alert(creditCardFormInvalidMessage);

				LoggerInstance.error(tokenizeError);

				deferred.reject(creditCardFormInvalidMessage);

				return;
			}

			if (window.braintree.threeDSecure) {
				that._threeDSecurePayment(deferred, clientInstance, payload, billingAddress);
			} else {
				deferred.resolve(payload);
			}
		});

		return deferred;
	},

	_threeDSecurePayment: function (deferred, clientInstance, tokenizedPayment, billingAddress) {
		var that = this;

		braintree.threeDSecure.create({
			version: 2,
			client: clientInstance
		}, function (threeDSecureInstanceError, threeDSecureInstance) {
			if (threeDSecureInstanceError) {
				var threeDSecureInstanceErrorMessage = that._getWizardErrorMessage(WizardConstants.WIZARDS.COMPANY_ERROR_MESSAGES, WizardConstants.BRAINTREE_MESSAGE_FIELDS.THREEDSECURE_SERVICE_UNAVAILABLE);
				BootstrapPrompt.alert(threeDSecureInstanceErrorMessage);
				LoggerInstance.error(threeDSecureInstanceError);
				deferred.reject();
				return;
			}

			var verificationDetails = that._getThreeDSecureVerificationDetails(tokenizedPayment, billingAddress);

			threeDSecureInstance.verifyCard(verificationDetails, function (verifyCardError, verifyCardResponse) {
				if (verifyCardError) {
					var verifyCardErrorMessage = that._getWizardErrorMessage(WizardConstants.WIZARDS.COMPANY_ERROR_MESSAGES, WizardConstants.BRAINTREE_MESSAGE_FIELDS.THREEDSECURE_VERIFICATION_FAILURE);
					BootstrapPrompt.alert(verifyCardErrorMessage);
					LoggerInstance.error(verifyCardError);
					deferred.reject();
					return;
				}

				var verificationData = verifyCardResponse.rawCardinalSDKVerificationData;
				var isConstituentCancelled = verificationData &&
					verificationData.Payment &&
					verificationData.Payment.ExtendedData &&
					verificationData.Payment.ExtendedData.ChallengeCancel &&
					verificationData.Payment.ExtendedData.ChallengeCancel === "01" // Constituent Clicked Cancel

				if (isConstituentCancelled) {
					LoggerInstance.debug(`3D Secure Verification was cancelled by the constituent.`);
					deferred.reject();
					return;
				}

				if (!verifyCardResponse.liabilityShifted) {
					var verifyCardErrorMessage = that._getWizardErrorMessage(WizardConstants.WIZARDS.COMPANY_ERROR_MESSAGES, WizardConstants.BRAINTREE_MESSAGE_FIELDS.THREEDSECURE_VERIFICATION_FAILURE);
					BootstrapPrompt.alert(verifyCardErrorMessage);
					LoggerInstance.error(`3D Secure Verification failed with status: ${verifyCardResponse.threeDSecureInfo.status}`);
					deferred.reject();
					return;
				}

				// upgrade the payload nonce to the 3D Secure Nonce
				tokenizedPayment.nonce = verifyCardResponse.nonce;
				deferred.resolve(tokenizedPayment);
			});
		});
	},

	getEftNonce: function (parent, payment, eftMessages) {
		var that = this;
		var $parent = $(parent || "body");

		// Get Client Token
		var $braintreeEftComponent = $parent.find("[data-component='eftPayment']");
		var clientToken = decodeURIComponent($braintreeEftComponent.attr(`data-braintree-client-token`));

		var deferred = $.Deferred();

		BootstrapPrompt.confirm({
			message: eftMessages.mandateText,
			btnOKLabel: eftMessages.mandateTextAcceptButtonLabel,
			btnCancelLabel: eftMessages.mandateTextDeclineButtonLabel,
			title: ""
		}, (result) => {
			if (result) {
				window.braintree.client.create({
					authorization: clientToken
				}, function (err, clientInstance) {
					if (err) {
						var errorMessage = eftMessages.serviceUnavailable;
						BootstrapPrompt.alert(errorMessage);
						LoggerInstance.error(err);
						deferred.reject(errorMessage);
						return;
					}

					window.braintree.usBankAccount.create({
						client: clientInstance,
					}, function (err, usBankAccountInstance) {
						if (err) {
							var errorMessage = eftMessages.serviceUnavailable;
							BootstrapPrompt.alert(errorMessage);
							LoggerInstance.error(err);
							deferred.reject(errorMessage);
							return;
						}

						var bankDetails = that._getBankDetails(payment);

						usBankAccountInstance.tokenize({
							bankDetails: bankDetails,
							mandateText: eftMessages.mandateText
						}, function (err, tokenizedPayload) {
							if (err) {
								var errorMessage = eftMessages.tokenizationFailed;
								BootstrapPrompt.alert(errorMessage);
								LoggerInstance.error(err);
								deferred.reject(errorMessage);
								return;
							}

							$braintreeEftComponent.attr("data-hosted-page-token", tokenizedPayload.nonce);
							payment.hostedPageToken = tokenizedPayload.nonce;
							deferred.resolve();
						});
					});
				});
			} else {
				var errorMessage = "The Braintree ACH Mandate was not accepted.";
				LoggerInstance.error(errorMessage);
				deferred.reject(errorMessage);
			}
		});

		return deferred;
	},

	getSecuredSavedPayment: function (deferred, paymentInformation) {
		var that = this;
		if (window.braintree.threeDSecure) {
			SavedPaymentsApi.createHostedPageTokenFromSavedPayment(paymentInformation.savedPaymentId)
				.done(tokenizedSavedPayment => {
					var clientInstance = {};

					var $braintreeCreditCardPayment = $("[data-component='braintreeCreditCardPayment']");
					if ($braintreeCreditCardPayment.length > 0) {
						clientInstance = $braintreeCreditCardPayment.first().prop("clientInstance");
					}

					var billingAddress = this._getBillingAddress({
						selectionType: Constants.BILLING_ADDRESS_SELECTION_TYPES.EXISTING,
						address: {
							id: tokenizedSavedPayment.billingAddressId
						}
					});

					// call 3D Secure Verification using the new nonce
					that._threeDSecurePayment(deferred, clientInstance, tokenizedSavedPayment, billingAddress);
				})
				.fail((error) => {
					deferred.reject(error);
				});
		} else {
			deferred.resolve();
		}
	},

	_getBankDetails: function (payment) {
		var bankDetails = {
			accountNumber: payment.accountNumber || "",
			routingNumber: payment.routingNumber || "",
			accountType: (payment.accountType && payment.accountType.toLowerCase()) || ""
		};

		var account = this._getAccount();

		if (!account) {
			return bankDetails;
		}

		var billingAddress = this._getBillingAddress(payment && payment.billingAddressInformation);

		if (billingAddress) {
			bankDetails.billingAddress = {
				streetAddress: billingAddress.line1,
				extendedAddress: billingAddress.line2,
				locality: billingAddress.city,
				region: billingAddress.state,
				postalCode: billingAddress.postalCode
			};
		}

		if (account.type === "O") {
			bankDetails.ownershipType = "business";
			bankDetails.businessName = account.organizationName || account.name;
		} else {
			bankDetails.ownershipType = "personal";
			bankDetails.firstName = account.firstName;
			bankDetails.lastName = account.lastName;
		}

		return bankDetails;
	},

	_getBillingAddress: function (billingAddressInformation) {
		var billingAddress = null;

		var account = this._getAccount();
		var primaryAddress = account && account.address;
		var otherAddresses = account && account.otherAddresses;

		var shipToAccount = this._getShipToAccount(account);
		var shippingAddress = shipToAccount && shipToAccount.address;

		var selectionType = billingAddressInformation && billingAddressInformation.selectionType;

		if (selectionType === Constants.BILLING_ADDRESS_SELECTION_TYPES.NEW) {
			billingAddress = billingAddressInformation.address;
		} else if (selectionType === Constants.BILLING_ADDRESS_SELECTION_TYPES.EXISTING) {
			var billingAddressId = billingAddressInformation.address && billingAddressInformation.address.id;

			if (billingAddressId) {
				if (primaryAddress && primaryAddress.id === billingAddressId) {
					billingAddress = primaryAddress;
				} else if (otherAddresses && otherAddresses.length > 0) {
					billingAddress = otherAddresses.find(address => address.id === billingAddressId);
				}
			}
		} else if (selectionType === Constants.BILLING_ADDRESS_SELECTION_TYPES.NEW_PRIMARY) {
			billingAddress = primaryAddress;
		} else if (selectionType === Constants.BILLING_ADDRESS_SELECTION_TYPES.NEW_SHIPPING) {
			billingAddress = shippingAddress;
		}

		if (!billingAddress) {
			// Find the default billing address

			// First, check to see if the shipping or primary default billing checkboxes were checked
			if (shippingAddress && shippingAddress.isDefaultBilling) {
				billingAddress = shippingAddress;
			} else if (primaryAddress && primaryAddress.isDefaultBilling) {
				billingAddress = primaryAddress;
			}

			if (!billingAddress) {
				// If no default billing checkboxes were checked, see if any "other address" is the default billing address
				if (otherAddresses && otherAddresses.length > 0) {
					billingAddress = otherAddresses.find(address => address.isDefaultBilling);
				}

				// Fall back to the primary address if no other address was the default billing address
				if (!billingAddress) {
					billingAddress = primaryAddress;
				}
			}
		}

		return billingAddress;
	},

	_getAccount: function () {
		var accountData = window.AccountActions.getLoggedInAccount(); // We use window.AccountActions here to prevent a circular dependency.

		// If we do not have a logged in account, try to get account data from the primary create account form
		if ($.isEmptyObject(accountData)) {
			accountData = AccountFormHelper.serializeCreateAccountFormOnly();
		}

		if (!accountData.type) {
			accountData.type = (accountData.organizationName || accountData.organizationType) ? "O" : "I";
		}

		return accountData;
	},

	_getThreeDSecureVerificationDetails: function (tokenizePayload, billingAddress) {
		var verificationDetails = {
			amount: (window.CheckoutActions && window.CheckoutActions.getTotalAmount()) || "0", // Required Field
			nonce: tokenizePayload.nonce || tokenizePayload.hostedPageToken, // Required Field
			bin: (tokenizePayload.details && tokenizePayload.details.bin) || tokenizePayload.bin // Required Field
		};

		var account = this._getAccount();

		if (!$.isEmptyObject(account)) {
			verificationDetails.email = (account.email && account.email.emailAddress) || "";

			if (!$.isEmptyObject(billingAddress)) {
				verificationDetails.billingAddress = {
					givenName: account.firstName,
					surname: account.lastName,
					phoneNumber: this._getPhoneNumberFromAccount(account),
					streetAddress: billingAddress.line1,
					extendedAddress: billingAddress.line2,
					locality: billingAddress.city,
					region: billingAddress.state,
					postalCode: billingAddress.postalCode,
					countryCodeAlpha2: this._getTwoCharacterCountryCode(billingAddress.country)
				};
			}
		}

		var shipToAccount = this._getShipToAccount(account);
		var shippingAddress = (shipToAccount && shipToAccount.address) || {};

		if (!$.isEmptyObject(shippingAddress)) {
			verificationDetails.additionalInformation = {
				// We are not sending 'workPhoneNumber' at this time, but it is an optional field.
				shippingGivenName: shipToAccount.firstName,
				shippingSurname: shipToAccount.lastName,
				shippingPhone: this._getPhoneNumberFromAccount(shipToAccount),
				shippingAddress: {
					streetAddress: shippingAddress.line1,
					extendedAddress: shippingAddress.line2,
					locality: shippingAddress.city,
					region: shippingAddress.state,
					postalCode: shippingAddress.postalCode,
					countryCodeAlpha2: this._getTwoCharacterCountryCode(shippingAddress.country)
				}
			};
		}

		// Required Field
		verificationDetails.onLookupComplete = function (data, next) {
			next(); // 3D Secure requires this function be sent as a parameter, and that it calls next().
		};

		return verificationDetails;
	},

	_getPhoneNumberFromAccount: function (account) {
		return account.phone &&
			(account.phone.internationalCode || "") +
			(account.phone.areaCode || "") +
			(account.phone.phoneNumber || "") +
			(account.phone.extension || "");
	},

	_getTwoCharacterCountryCode: function (country) {
		if (country === "USA") {
			return "US";
		}

		return (country && country.length === 2) ? country : "";
	},

	_getShipToAccount: function (primaryAccount) {
		var shipToAccount = ShipToAccountHelper.getShippingAccountInfo(primaryAccount) || {};

		var isOnlyAddressId = shipToAccount.address &&
			shipToAccount.address.id &&
			!shipToAccount.address.line1 &&
			!shipToAccount.address.city &&
			!shipToAccount.address.state &&
			!shipToAccount.address.postalCode &&
			!shipToAccount.address.country;

		if (isOnlyAddressId) {
			// We only get here when using an existing Other Address for shipment.
			var otherAddresses = window.AccountActions.getOtherAddresses(); // We use window.AccountActions here to prevent a circular dependency.

			var shipToAddress = _.find(otherAddresses, (otherAddress) => {
				return (otherAddress.id === shipToAccount.address.id);
			});

			shipToAccount.address = shipToAddress || {};
		}

		return shipToAccount;
	},

	_generateIframe: function ($parent) {
		var that = this;
		var device = this._getDeviceType();

		// Find Braintree Components
		var $braintreeCardNumberComponent = $parent.find("[data-component='braintreeCardNumber.input']");
		var $braintreeExpirationComponent = $parent.find("[data-component='braintreeExpiration.input']");
		var $braintreeCardVerificationValueComponent = $parent.find("[data-component='braintreeCardVerificationValue.input']");
		var $braintreeNameOnCardComponent = $parent.find("[data-component='braintreeNameOnCard.input']");

		// Get Style Objects
		var cardNumberStyle = this._getStyleObject($braintreeCardNumberComponent, device);
		var expirationStyle = this._getStyleObject($braintreeExpirationComponent, device);
		var cardVerificationValueStyle = this._getStyleObject($braintreeCardVerificationValueComponent, device);
		var nameOnCardStyle = this._getStyleObject($braintreeNameOnCardComponent, device);

		// Get Iframe Styling
		var braintreeStyles = {};
		braintreeStyles['.number'] = cardNumberStyle;
		braintreeStyles['.expirationDate'] = expirationStyle;
		braintreeStyles['.cvv'] = cardVerificationValueStyle;
		braintreeStyles['.cardholderName'] = nameOnCardStyle;

		// Set Container Styling
		this._setContainerHeightAndWidth($braintreeCardNumberComponent, cardNumberStyle);
		this._setContainerHeightAndWidth($braintreeExpirationComponent, expirationStyle);
		this._setContainerHeightAndWidth($braintreeCardVerificationValueComponent, cardVerificationValueStyle);
		this._setContainerHeightAndWidth($braintreeNameOnCardComponent, nameOnCardStyle);

		// Create Braintree Fields
		var braintreeFields = {};
		braintreeFields['number'] = {
			container: `#${$braintreeCardNumberComponent.attr("id")}`,
			placeholder: decodeURIComponent($braintreeCardNumberComponent.attr(`data-input-placeholder`)),
			maskInput: {
				showLastFour: true
			}
		};
		braintreeFields['expirationDate'] = {
			container: `#${$braintreeExpirationComponent.attr("id")}`,
			placeholder: decodeURIComponent($braintreeExpirationComponent.attr(`data-input-placeholder`))
		};
		braintreeFields['cvv'] = {
			container: `#${$braintreeCardVerificationValueComponent.attr("id")}`,
			placeholder: decodeURIComponent($braintreeCardVerificationValueComponent.attr(`data-input-placeholder`))
		};
		braintreeFields['cardholderName'] = {
			container: `#${$braintreeNameOnCardComponent.attr("id")}`,
			placeholder: decodeURIComponent($braintreeNameOnCardComponent.attr(`data-input-placeholder`))
		};

		// Get Client Token
		var clientToken = decodeURIComponent($braintreeCardNumberComponent.attr(`data-client-token`));

		window.braintree.client.create({
			authorization: clientToken
		}, function (err, clientInstance) {
			if (err) {
				var paymentFormUnavailableMessage = that._getWizardErrorMessage(WizardConstants.WIZARDS.COMPANY_ERROR_MESSAGES, WizardConstants.BRAINTREE_MESSAGE_FIELDS.PAYMENT_FORM_UNAVAILABLE);
				BootstrapPrompt.alert(paymentFormUnavailableMessage);
				LoggerInstance.error(err);
				return;
			}

			window.braintree.hostedFields.create({
				client: clientInstance,
				styles: braintreeStyles,
				fields: braintreeFields
			}, function (err, hostedFieldsInstance) {
				if (err) {
					var paymentFormUnavailableMessage = that._getWizardErrorMessage(WizardConstants.WIZARDS.COMPANY_ERROR_MESSAGES, WizardConstants.BRAINTREE_MESSAGE_FIELDS.PAYMENT_FORM_UNAVAILABLE);
					BootstrapPrompt.alert(paymentFormUnavailableMessage);
					LoggerInstance.error(err);
					return;
				}

				hostedFieldsInstance.on('validityChange', function (event) {
					var field = event.fields[event.emittedBy];

					if (!field.isValid) {
						$(field.container).parent().addClass("invalid");
					} else {
						$(field.container).parent().removeClass("invalid");
					}
				});

				$parent.find("[data-component='braintreeCreditCardPayment']").prop("hostedFieldsInstance", hostedFieldsInstance);
				$parent.find("[data-component='braintreeCreditCardPayment']").prop("clientInstance", clientInstance);
			});
		});
	},

	_getStyleObject: function ($component, device) {
		var styleString = decodeURIComponent($component.attr(`data-src-${device}-css`));
		var styleString = styleString.replace("{", "").replace("}", "");
		var styleObject = {};
		var rules = styleString.split(";");

		rules.forEach(rule => {
			var keyValuePair = rule.split(":");
			if (keyValuePair.length === 2) {
				styleObject[keyValuePair[0]] = keyValuePair[1];
			}
		});
		
		return styleObject;
	},

	_setContainerHeightAndWidth: function ($component, styleObject) {
		var marginTop = styleObject["margin-top"] || "0px";
		var marginRight = styleObject["margin-right"] || "0px";
		var marginBottom = styleObject["margin-bottom"] || "0px";
		var marginLeft = styleObject["margin-left"] || "0px";

		$component.css("height", `calc(100% + ${marginTop} + ${marginBottom})`);
		$component.css("width", `calc(100% + ${marginLeft} + ${marginRight})`);
	},

	_getDeviceType: function () {
		var width = window.innerWidth;

		return (width < deviceMinWidth.TABLET && deviceType.MOBILE)
			|| (width < deviceMinWidth.DESKTOP && deviceType.TABLET)
			|| deviceType.DESKTOP;
	},

	_getWizardErrorMessage: function (wizardName, wizardField) {
		if (window.CheckoutActions) {
			return window.CheckoutActions.getWizardValue(wizardName, wizardField);
		}

		return window.AccountStore.getWizardValue(wizardName, wizardField);
	}
};

module.exports = BraintreeHelper;



// WEBPACK FOOTER //
// ./Javascript/commonComponents/BraintreeHelper.jsx